<template>
  <div class="homeContainer">
    <h5 class="description">
      The following entities or their affiliates have either donated substantial
      amounts of money to the Trump2020 campaign, or have
      been vocal or transparent about their support. In the best
      interest of the black community, they should be boycotted by the black economy.
    </h5>
    <p class="disclaimer">*The entries listed are subject to change.</p>
    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        v-for="(listCategory, idx) in listCategories"
        :key="idx"
        @click="onSelect(listCategory)"
        :class="evalCategory(listCategory)"
      >
        <div class="category">
          {{ listCategory }}
        </div>
      </button>
    </div>
    <div class="listContainer">
      <List :currentList="selection"/>
    </div>
  </div>
</template>

<script>
import List from '../components/List.vue';

export default {
  components: {
    List,
  },
  data() {
    return {
      selection: '',
    };
  },
  methods: {
    onSelect(cat) {
      this.selection = cat;
    },
    evalCategory(section) {
      let currentClass = 'categoryPicker';
      currentClass += this.selection === section ? ' picked' : ' normal';
      return currentClass;
    },
  },
  computed: {
    listCategories() {
      return this.$store.getters.getCategories;
    },
  },
  watch: {
    listCategories(newVal) {
      if (newVal.length > 0) {
        this.onSelect(newVal[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../style/colors.sass';
.description {
  margin: 18px;
}

.categoryPicker {
  border: 1px solid $azure;
  padding: 20px 12px;
  font-size: 15px;
  outline: none;
}

.normal {
  background-color: $onyx;
  color: $azure;
}

.picked {
  background-color: $azure;
  color: $onyx;
}
</style>
